import Qmath from '../views/pages/qmath';

const routes = {
  '/': Qmath,
};

export default routes;
